import { useQuoteParams } from '@/features/quotes/context/quote-params.context';
import { coveragesService } from '@/services/coverages';
import type { Coverage } from '@/services/coverages/types';
import { useQuery } from '@tanstack/react-query';

type UseCoveragesOptions = {
  enabled?: boolean;
};

export function useCoverages(
  versionDate: string,
  options?: UseCoveragesOptions
) {
  const { productCode } = useQuoteParams();

  return useQuery({
    queryKey: ['product-coverages', productCode, versionDate],
    enabled: Boolean(productCode) && (options?.enabled ?? true),
    queryFn: async (): Promise<Coverage[]> => {
      const result = await coveragesService.getCoverages(
        productCode,
        versionDate
      );
      if (!result.success || !result.data) {
        throw new Error(result.error || 'Falha ao buscar coberturas');
      }
      return result.data;
    },
  });
}
